import { METRICS, SEND_METRICS} from "../actions/metrics";

const initialState = {
  payload: {}
};

const setSendMethod = (dataLayer) => {
    if(dataLayer.hitType)
	   window.ga('send', dataLayer.hitType, dataLayer);
};

const createMetrics = (executor, payload) => {
	const isEmpty = (obj) => {
		return Object.keys(obj).length === 0 && obj.constructor === Object;
	}
  if(!isEmpty(payload)) return setSendMethod(payload);
};


const setMetrics = (state = initialState, action = {}) => {
	switch (action.type) {
        case 'METRICS':
          return { payload: action.payload };
          break;
        case 'SEND_METRICS':
        	const result = action.result;
        	createMetrics(result.executor, result.payload);
        	return { payload: {} }
          break;
    }
    return state;
}

export default setMetrics;



// WEBPACK FOOTER //
// ./src/reducers/metrics.js